module.exports = __webpack_public_path__ + "static/stubhub-a6e7f93b7d82e311a883bca59aff7b5e.png";